import { Grid, Tooltip} from "@mui/material";

export function getProductrawStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'title',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        productid:{
            name:'productid',
            label:'product Id',
            value:'',
            error:false,
            errorMessage:'You must enter product Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        productname:{
            name:'productname',
            label:'product Name',
            value:'',
            error:false,
            errorMessage:'You must enter product Name',
            required:true,
            fieldtype:'string'
        },
        rmid:{
            name:'rmid',
            label:'rm Id',
            value:'',
            error:false,
            errorMessage:'You must enter rm Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        rmname:{
            name:'rmname',
            label:'rm Name',
            value:'',
            error:false,
            errorMessage:'You must enter rm Name',
            required:true,
            fieldtype:'string'
        },
        qty:{
            name:'qty',
            label:'qty',
            value:'',
            error:false,
            errorMessage:'You must enter qty',
            required:true,
            fieldtype:'number'
        },
        unitid:{
            name:'unitid',
            label:'Unit Id',
            value:'',
            error:false,
            errorMessage:'You must enter Unit Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        unitname:{
            name:'unitname',
            label:'Unit Name',
            value:'',
            error:false,
            errorMessage:'You must enter Unit Name',
            required:true,
            fieldtype:'string'
        },
        status:{
            name:'status',
            label:'Status',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'productname', headerName: 'product Name', width:150 },
        { field: 'rmname', headerName: 'rm Name', width:150 },
        { field: 'qty', headerName: 'qty', width:150 },
        { field: 'unitname', headerName: 'Unit Name', width:150 },
        { field: 'status', headerName: 'Status', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['productid']:{
          ...formValues['productid'],
          value:data.productid,
        },['productname']:{
          ...formValues['productname'],
          value:data.productname,
        },['rmid']:{
          ...formValues['rmid'],
          value:data.rmid,
        },['rmname']:{
          ...formValues['rmname'],
          value:data.rmname,
        },['qty']:{
          ...formValues['qty'],
          value:data.qty,
        },['unitid']:{
          ...formValues['unitid'],
          value:data.unitid,
        },['unitname']:{
          ...formValues['unitname'],
          value:data.unitname,
        },['status']:{
          ...formValues['status'],
          value:data.status,
        },
      })
}